/**
 * About Page (v0.10.0 - Issue #388)
 *
 * Personal founder story and mission for ORO move.
 * Content lives in data/content/about.ts (#2212 — shared with the native
 * About screen). The closing login CTA is web-only page chrome.
 */

import { useAuthModal } from '../contexts/AuthModalContext';
import PageLayout from '../components/PageLayout';
import ContentDocView from '../components/ContentDocView';
import { ABOUT_DOC } from '../data/content/about';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { MARKETING_PAGE_META } from '../lib/seo/pageMeta';

export default function AboutPage() {
  useDocumentTitle(MARKETING_PAGE_META['/about'].title, { suffix: false });
  const { openLoginModal } = useAuthModal();

  return (
    <PageLayout title="About">
      <ContentDocView doc={ABOUT_DOC}>
        <div className="text-center">
          <button
            onClick={() => openLoginModal('/home')}
            className="bg-accent text-black px-6 py-3 rounded-lg font-medium hover:bg-accent-light transition-colors"
          >
            Open ORO move
          </button>
        </div>
      </ContentDocView>
    </PageLayout>
  );
}
